import React from 'react'

import { SH3, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'

export default function ProductSeparator() {
  return (
    <XStack className="mt-2 items-center justify-between px-3">
      <LinearGradient
        colors={['#145CC5', '#fff']}
        start={{ x: 1, y: 0 }}
        end={{ x: 0, y: 0 }}
        className={`h-1 w-[35%] rounded-r-sm`}
      />
      <SH3>{i18n.t('brandPage.otherOffers')}</SH3>
      <LinearGradient
        colors={['#145CC5', '#fff']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        className={`h-1 w-[35%] rounded-l-sm`}
      />
    </XStack>
  )
}
